import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Controlla se l'utente ha già fatto una scelta
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  const handleClose = () => {
    // Chiudendo il banner = accetta implicitamente
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-4 border-burgundy shadow-2xl z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* Testo */}
          <div className="flex-1">
            <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
              <span className="font-semibold text-burgundy">🍪 Cookie Policy: </span>
              Questo sito utilizza solo cookie tecnici e funzionali necessari per garantire la funzionalità di base. 
              Puoi Accettare o Rifiutare. Chiudendo questo banner o continuando la navigazione acconsenti all'uso dei cookie.
            </p>
          </div>

          {/* Pulsanti */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0 w-full sm:w-auto">
            <button
              onClick={handleAccept}
              style={{ backgroundColor: '#8B1538', color: '#FFFFFF' }}
              className="hover:opacity-90 px-4 sm:px-6 py-2 text-sm font-medium rounded-lg transition-all flex-1 sm:flex-none"
            >
              Accetta
            </button>
            <button
              onClick={handleReject}
              style={{ borderColor: '#8B1538', color: '#8B1538' }}
              className="border-2 hover:bg-burgundy/10 px-4 sm:px-6 py-2 text-sm font-medium rounded-lg transition-all flex-1 sm:flex-none bg-white"
            >
              Rifiuta
            </button>
            <button
              onClick={handleClose}
              className="p-2 text-gray-500 hover:text-burgundy hover:bg-burgundy/10 rounded-full transition-all flex-shrink-0"
              aria-label="Chiudi"
            >
              <X size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
